// extracted by mini-css-extract-plugin
module.exports = {"thumbnailImage":"_1FovXE7","steps":"_-TRA9xU"};